"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_DOCUMENT_SECTION = exports.COMPANY_OWNER_ENTITY_TYPE = exports.COMPANY_DOCUMENT_TYPE_REQUIRES_EXPIRY = exports.COMPANY_DOCUMENT_TYPE_LABELS = exports.companyDocumentTypeSchema = exports.COMPANY_DOCUMENT_TYPES = void 0;
const zod_1 = require("zod");
exports.COMPANY_DOCUMENT_TYPES = [
    'kyb_cert_of_incorporation',
    'kyb_ubo_declaration',
    'kyb_recycling_licence',
    'kyb_trade_reference',
];
exports.companyDocumentTypeSchema = zod_1.z.enum(exports.COMPANY_DOCUMENT_TYPES);
exports.COMPANY_DOCUMENT_TYPE_LABELS = {
    kyb_cert_of_incorporation: 'Certificate of incorporation',
    kyb_ubo_declaration: 'Shareholding / UBO declaration',
    kyb_recycling_licence: 'Recycling licence',
    kyb_trade_reference: 'Trade reference',
};
exports.COMPANY_DOCUMENT_TYPE_REQUIRES_EXPIRY = {
    kyb_cert_of_incorporation: false,
    kyb_ubo_declaration: false,
    kyb_recycling_licence: true,
    kyb_trade_reference: false,
};
exports.COMPANY_OWNER_ENTITY_TYPE = 'company';
exports.COMPANY_DOCUMENT_SECTION = 'kyb';
//# sourceMappingURL=company-document-types.js.map